export var listItemStyles = {
  w: '48',
  mb: '1',
  _focusVisible: {
    outline: 'none'
  },
  _hover: {
    a: {
      textDecoration: 'underline'
    }
  }
};
export var businessListStyles = {
  w: '48',
  fontWeight: 'medium'
};
export var listStyles = {
  w: '48',
  mr: '5',
  color: 'darkGrey1',
  mb: '0',
  ml: '0',
  listStyleType: 'none'
};
export var headingStyles = {
  _focusVisible: {
    outline: 'none'
  },
  fontSize: 'md',
  lineHeight: 3,
  mb: 'sm',
  fontWeight: 'semibold'
};
export var linkStyles = {
  cursor: 'pointer',
  _hover: {
    textDecoration: 'underline'
  },
  _focusVisible: {
    outline: 'none'
  },
  fontWeight: 'medium',
  fontSize: 'md',
  mb: 0
};
export var boxStyles = {
  mr: {
    lg: '1.875rem',
    xl: '1.625rem'
  },
  _focusVisible: {
    outline: 'none'
  },
  mb: 0
};